// extracted by mini-css-extract-plugin
export default {"image":"image--IQ0Le","title":"title--k4zv9","item":"item--nGU7V","footerInfo":"footerInfo--fpNh0","dropdownContent":"dropdownContent--ewMzj"};